import { render, staticRenderFns } from "./IndividualCourseLectureRankingPanel.vue?vue&type=template&id=10bef4c8&scoped=true"
import script from "./IndividualCourseLectureRankingPanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseLectureRankingPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualCourseLectureRankingPanel.vue?vue&type=style&index=0&id=10bef4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bef4c8",
  null
  
)

export default component.exports